import React, { useEffect, useState } from "react";
import { Toaster, useToastController } from "@fluentui/react-toast";
import toastEmitter from "../../utils/toastEmitter";
import configManagerEmitter from "../../utils/configManagerEmitter";

const toasterId = "notifications-center-toaster";
const TOAST_LIMIT = 2;
const DEFAULT_POSITION = "top";

export const NotificationsCenterToaster = () => {
  const { dispatchToast, dismissToast } = useToastController(toasterId);

  const [position, setPosition] = useState(DEFAULT_POSITION);
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    const handleConfigUpdated = config => {
      setIsEnabled(config.notifications?.enabled ?? false);
      setPosition(config.notifications?.position ?? DEFAULT_POSITION);
    };

    configManagerEmitter.on("configUpdated", handleConfigUpdated);

    return () => {
      configManagerEmitter.off("configUpdated", handleConfigUpdated);
    };
  }, []);

  useEffect(() => {
    const handleToast = (toastContent, options) => {
      if (!isEnabled) return;

      try {
        dispatchToast(toastContent, {
          ...options,
          position
        });
      } catch (error) {
        console.error("Failed to dispatch toast:", error);
      }
    };

    const handleDismissToast = id => {
      try {
        dismissToast(id);
      } catch (error) {
        console.error("Failed to dismiss toast:", error);
      }
    };

    toastEmitter.on("toast", handleToast);
    toastEmitter.on("dismissToast", handleDismissToast);

    return () => {
      toastEmitter.off("toast", handleToast);
      toastEmitter.off("dismissToast", handleDismissToast);
    };
  }, [dispatchToast, dismissToast, isEnabled, position]);

  return <Toaster limit={TOAST_LIMIT} toasterId={toasterId} position="top" />;
};
